import { useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import MainLayout from './components/Layout/MainLayout'
import PrivateRoute from './components/Common/PrivateRoute'
import Login from './pages/Login'
import LoggedOut from './pages/LoggedOut'
import OAuthCallback from './pages/OAuthCallback'
import Dashboard from './pages/Dashboard'
import TaskNew from './pages/TaskNew'
import TaskDetail from './pages/TaskDetail'
import TaskHistory from './pages/TaskHistory'
import ScheduledTasks from './pages/ScheduledTasks'
import ScheduledTaskNew from './pages/ScheduledTaskNew'
import PurchaseHistory from './pages/PurchaseHistory'
import SupportContact from './pages/SupportContact'
import Profile from './pages/Profile'
import { verifyToken } from './store/slices/authSlice'

function App() {
  const dispatch = useDispatch()
  const { token, user } = useSelector((state) => state.auth)

  useEffect(() => {
    if (token && !user) {
      dispatch(verifyToken())
    }
  }, [token, user, dispatch])

  return (
    <Routes>
      <Route path="/login" element={token ? <Navigate to="/dashboard" /> : <Login />} />
      <Route path="/callback" element={<OAuthCallback />} />
      <Route path="/logged-out" element={<LoggedOut />} />

      <Route path="/" element={<PrivateRoute><MainLayout /></PrivateRoute>}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="tasks/new" element={<TaskNew />} />
        <Route path="tasks/:taskId" element={<TaskDetail />} />
        <Route path="tasks" element={<TaskHistory />} />
        <Route path="scheduled-tasks" element={<ScheduledTasks />} />
        <Route path="scheduled-tasks/new" element={<ScheduledTaskNew />} />
        <Route path="purchases" element={<PurchaseHistory />} />
        <Route path="profile" element={<Profile />} />
        <Route path="support/contact" element={<SupportContact />} />
      </Route>

      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  )
}

export default App
